import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, Redirect} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import YCComponent from "./yc-component";
import {Modal} from "reactstrap";
import YouTube from 'react-youtube';

class VideoBtn extends YCComponent {

    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    render() {
        return (
            <div className={'video-btn '+(this.props.className ? this.props.className : '')}>
                <div className={(this.props.btnClassName ? this.props.btnClassName : 'btn btn-white-secondary')} onClick={this.toggle}>{ this.props.children || <span><FontAwesomeIcon icon={['fas', 'play']}/> video</span> }</div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} modalTransition={{ timeout: 200 }} backdropTransition={{ timeout: 200 }} className={'video-modal'}>
                    <div className='video-container'><YouTube opts={{width: '100%', modestbranding: true, iv_load_policy: 3}} videoId={this.props.videoId}/></div>
                </Modal>
            </div>
        );
    }
}

export default VideoBtn;
